import React from "react";
import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Card,
  Table,
  Image
} from "react-bootstrap";

const BorkerBenefits_v03: React.FC = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">Insurance Broker vs. <br className="responsive-break"></br>Captive Agent</h2>

      <Tab.Container defaultActiveKey="broker">
        <Row>
          <Col md={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="broker">Insurance Broker</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="captive">Captive Agent</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="summary">Summary</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="final">Final Thoughts</Nav.Link>
              </Nav.Item>
            </Nav>

              


                {/* Add your actual image path here */}
            <div className="text-center mb-4">
                <Image className="BrokerVsCaptiveImg"
                src="/insurance/images/broker-vs-agent.png" // Replace with actual image path
                alt="Captive Agent vs Insurance Broker"
                fluid
                rounded
                />
            </div>


          </Col>
       
          <Col md={9}>
                   <Tab.Content>
                     <Tab.Pane eventKey="broker">
                       <Card>
                         <Card.Body>
                           <Card.Title>Insurance Broker</Card.Title>
                           <ul>
                             <li><strong>Independent:</strong> <br></br>Works for the customer.</li>
                             <li><strong>Access to Multiple Carriers:</strong> <br></br>Brokers work with many different insurance companies, allowing them to compare quotes and find the best coverage and price for your needs.</li>
                             <li><strong>Objective Advice:</strong> <br></br>Since they’re not tied to one company, brokers offer unbiased recommendations based solely on what’s best for the client.</li>
                             <li><strong>Better Price Options:</strong><br></br> With more options, brokers can help find competitive pricing, discounts, or bundled policies that a single carrier might not offer.</li>
                             <li><strong>Customized Coverage:</strong><br></br> They can tailor policies across different insurers to create a fully customized insurance package for your specific situation.</li>
                             <li><strong>Advocacy in Claims:</strong><br></br> Brokers serve as your advocate during the claims process, helping you deal with the insurance company if problems arise.</li>
                             <li><strong>Expertise Across Multiple Lines:</strong><br></br> Brokers often specialize in multiple types of insurance—home, auto, life, business, etc.—offering a comprehensive view of your protection needs.</li>
                           </ul>
                         </Card.Body>
                       </Card>
                     </Tab.Pane>
       
                     <Tab.Pane eventKey="captive">
                       <Card>
                         <Card.Body>
                           <Card.Title>Captive Agent</Card.Title>
                           <ul>
                             <li><strong>Captive:</strong><br></br> Tied to a single insurance company.</li>
                             <li><strong>Only Offer One Company’s Products:</strong><br></br> Captive agents can only sell policies from their company, which limits your options and may not result in the best price or fit.</li>
                             <li><strong>Company-Centric Recommendations:</strong><br></br> Advice may be biased toward meeting company sales goals rather than optimizing your coverage.</li>
                             <li><strong>Less Price Flexibility:</strong> <br></br>If your rates go up, they can’t shop around for you—your only option is to accept the increase or switch agents entirely.</li>
                             <li><strong>Limited Product Variety:</strong><br></br> Some captive agents may not offer certain specialty or commercial policies that independent brokers can source.</li>
                           </ul>
                         </Card.Body>
                       </Card>
                     </Tab.Pane>
       
                     <Tab.Pane eventKey="summary">
                       <Card>
                         <Card.Body>
                           <Card.Title></Card.Title>
                           <Table striped bordered hover responsive>
                             <thead>
                               <tr>
                                 <th>Feature</th>
                                 <th>Insurance Broker</th>
                                 <th>Captive Agent</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr>
                                 <td>Number of Insurance Carriers</td>
                                 <td>Many</td>
                                 <td>One</td>
                               </tr>
                               <tr>
                                 <td>Unbiased Advice</td>
                                 <td>✅ Yes</td>
                                 <td>❌ No</td>
                               </tr>
                               <tr>
                                 <td>Price Shopping = saving$$$!</td>
                                 <td>✅ Yes</td>
                                 <td>❌ No</td>
                               </tr>
                               <tr>
                                 <td>Custom Coverage Packages</td>
                                 <td>✅ Yes</td>
                                 <td>❌ Limited</td>
                               </tr>
                               <tr>
                                 <td>Claims Advocacy</td>
                                 <td>✅ Yes</td>
                                 <td>⚠️ Sometimes</td>
                               </tr>
                               <tr>
                                 <td>Product Flexibility</td>
                                 <td>✅ Broad range</td>
                                 <td>❌ Limited to one brand</td>
                               </tr>
                             </tbody>
                           </Table>
                         </Card.Body>
                       </Card>
                     </Tab.Pane>
       
                     <Tab.Pane eventKey="final">
                       <Card>
                         <Card.Body>
                           <Card.Title>Final Thoughts</Card.Title>
                           <p>
                             A <strong>captive agent</strong> might be a good fit if you're loyal to a specific brand or only need basic coverage from a well-known carrier.
                             <br></br><br></br>
       
                             <strong>However...</strong><br></br>
                             If you want <strong>choice, value, advocacy, <i>all at a lower price<span style={{color:'green'}}>$</span></i></strong>, a <strong>broker</strong> is typically the smarter option—
                             especially for complex or bundled insurance needs.
                             
                           </p>
                         </Card.Body>
                       </Card>
                     </Tab.Pane>
                   </Tab.Content>
                 </Col>
        </Row>
      </Tab.Container>



    </Container>
  );
};

export default BorkerBenefits_v03;
